import loadImage from 'blueimp-load-image';

//画像ファイルプレビュー表示のイベント追加 fileを選択時に発火するイベントを登録
$(document).on('change', 'input[type="file"]', function(e) {
    let self = this,
        file = e.target.files[0],
        reader = new FileReader(),
        file_type = $(self).data('file_type');

    if (!check_upload_file(file, file_type)) {
        $(self).val('');
        return;
    }

    // ファイル読み込みが完了した際のイベント登録
    if (file_type === 'image') {
        reader.onload = (function(file) {
            return function(e) {
                setImagePreview($(self).closest('.form_image_wrapper'), e.target.result);
            };
        })(file);

        reader.readAsDataURL(file);
    }
});

// プレビューはめ込み
let setImagePreview = function($image_area, src) {

    loadImage(
        src,
        function (canvas) {
            $image_area.find('.preview_image').html(canvas);
        },
        {
            maxHeight: $image_area.height(),
            maxWidth: $image_area.width(),
            canvas: true,
            orientation: true,
            crop: $image_area.data('img-crop')
        } // Options
    );
    // 画像・削除ボタン表示、一括アップロード・ファイル選択を非表示
    $image_area.find('.preview_image').addClass('d-flex justify-content-center align-items-center');
    $image_area.find('.preview_image').show();
    $image_area.find('.btn_delete').show();
    $image_area.find('.check_cw_remove').prop('checked', false);
    $image_area.find('.form_image_remove').show();
    $image_area.find('.image_drop_area').hide();
}

document.addEventListener("turbolinks:load", function (e) {
    // 画像削除
    $('.form_image_remove').click(function() {
        let form_image_wrapper = $(this).closest('.form_image_wrapper');
        // 画像・削除ボタンを非表示、一括アップロード・ファイル選択を表示
        form_image_wrapper.find('.preview_image').removeClass('d-flex justify-content-center align-items-center');
        form_image_wrapper.find('.preview_image').hide();
        form_image_wrapper.find('.form_image_remove').hide();
        form_image_wrapper.find('.image_drop_area').show();
        form_image_wrapper.find('.form_image').val('');
        form_image_wrapper.find('.check_cw_remove').prop('checked', true);
        form_image_wrapper.find('.hidden_cw_cache').val('');
    })

    // ドラッグドロップ
    // ブラウザ上でファイルを展開する挙動を抑止
    $(document).on('dragover', '.image_drop_area', function(e) {
        e.preventDefault();
    })
    // Drop領域にドラッグ
    $(document).on('dragenter', '.image_drop_area', function(e) {
        e.preventDefault();
        $(this).addClass('bg-light');
    })
    // Drop領域にドロップした際のファイルのはめ込み
    $(document).on('drop', '.image_drop_area', function(e) {
        e.preventDefault();
        let $input_wrapper = $(this).closest('.form_image_wrapper');
        let $input = $input_wrapper.find('.form_image');
        let drop_file = e.originalEvent.dataTransfer.files[0];
        if (!check_upload_file(drop_file, 'image')) {
            $input.val('');
            $(this).removeClass('bg-light');
            return;
        }

        let reader = new FileReader();
        reader.onload = (function(file) {
            return function(e) {
                setImagePreview($input_wrapper, e.target.result);
            };
        })(drop_file);

        reader.readAsDataURL(drop_file);
        $input.get(0).files = e.originalEvent.dataTransfer.files;
        $(this).removeClass('bg-light');
    })
    // Drop領域からの離脱
    $(document).on('dragleave', '.image_drop_area', function(e) {
        $(this).removeClass('bg-light');
    })
})

// ファイルチェック
let check_upload_file = function(file, type) {
    let enable_types = {
        'image': {
            'extentions': ['image/jpg', 'image/jpeg', 'image/png', 'image/gif'],
            'message': 'ファイルはjpeg, jpg, png, gifのみ指定可能です。',
            'max': 10
        },
        'other':   {
            'max': 50
        },
    };

    let extension = false;
    const extensions = enable_types[type]['extentions'];
    if (extensions !== undefined) {
        enable_types[type]['extentions'].forEach(function(file_type) {
            if(file.type.toLowerCase().indexOf(file_type) >= 0){
                extension = true;
            }
        });
        if (!extension) {
            $.NotificationApp.send('',enable_types[type]['message'],'bottom-left','rgba(0,0,0,0.2)', 'error')
            file = null;
            return false;
        }
    }

    if (file.size > 1024 * 1024 * enable_types[type]['max']) {
        $.NotificationApp.send('','ファイルのサイズは' + enable_types[type]['max'] + 'MBまで指定可能です。','bottom-left','rgba(0,0,0,0.2)', 'error')
        file = null;
        return false;
    }
    return true;
}